const config = {
  apiUrl: 'https://staging.lawnpride.com.au/backend/api',
  appUrl: '/',
};

export default config;